<template>
    <div class="new_content"> 
        <div class="flex_spw cont_heard " >
            <Button @click="addProduct()" style="background:#FF761D;color:#fff;border-color:#FF761D">创建插件套餐</Button>
            <div class="flex_sta" >               
                <div style="margin-right:16px">                   
                    <Select filterable  transfer  @on-change="changeAppid" v-model="pageForm.application_id" style="width:150px" placeholder="请选择产品搜索" clearable >
                        <Option v-for="item in applicationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>      
                    <Select filterable transfer :disabled="pageForm.application_id ? false : true"  v-model="pageForm.version_plugin_id" style="width:150px;margin-left: 16px;" placeholder="请选择版本插件" clearable >
                        <Option v-for="item in searchVersionList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>                 
                </div>               
                <Button @click="goSearch()" style="background:#FF761D;color:#fff;border-color:#FF761D">搜索</Button>                
            </div>
        </div>
        <!-- @on-selection-change="chooseData" -->
        <div class="cont_tab">
            <Table :columns="columns12" :data="data6" :loading="loadingone " >
                <template slot-scope="{ index }" slot="index">
                    <strong>{{ index+1 }}</strong>
                </template>
                <template slot-scope="{ row }" slot="plugin">
                    <div style="padding:8px 0">
                        <div v-for="(item,index) in row.plugin_object" :key="index">
                            {{ item.num ? (item.name+':'+item.num):item.name }}
                        </div>                    
                    </div>
                </template>  
                <template slot-scope="{ row }" slot="system">
                    <div style="padding:8px 0">
                        {{ row.application?row.application.name:'' }}
                    </div>
                </template>    
                <template slot-scope="{ row }" slot="version_plugin_name">
                    <div style="padding:8px 0">
                        {{ row.version_plugin?row.version_plugin.name:'' }}
                    </div>
                </template>    
                                 
                <template slot-scope="{ row }" slot="action">
                    <Button @click="goEdit(row)" style="color:#3C90EE;background: unset;" type="text">修改</Button>
                    <Button @click="del_use(row)" style="color:#12B130;background: unset;" type="text">删除</Button>
                </template>
            </Table>
            <br />
            <Page :total="total" :current="pageForm.page" @on-change="pageChange" show-total show-elevator style="text-align:right" />
        </div>
        
        <Modal v-model="showAddModal" width="1010" :mask-closable="false">
            <p slot="header" style="text-align:center">
                <span>{{ addModalTitle == 'add' ? '创建' : '修改' }}</span>
            </p>
            <div class="flex_cen">
                <div class="form_box_two">    
                    <div class="form_item_box_one" >
                        <div class="form_label_one">序号:</div>
                        <div class="form_conter" >
                            <Input  v-model="submitData.sort" type="number" style="width:300px" placeholder="请输入排序序号(不填默认为0)"></Input>
                        </div>
                    </div>
                    <div class="form_item_box_one" >
                        <div class="form_label_one">套餐名称:</div>
                        <div class="form_conter" >
                            <Input v-model="submitData.name" style="width:300px" placeholder="请输入套餐名称"></Input>
                        </div>
                    </div>    
                    <div class="form_item_box_one" >
                        <div class="form_label_one">金额:</div>
                        <div class="form_conter" >
                            <InputNumber :min="0" v-model="submitData.price" style="width:300px"  placeholder="请输入金额"></InputNumber>
                            <!-- <Input v-model="submitData.price" type="number" style="width:300px" placeholder="请输入金额"></Input> -->
                        </div>
                    </div>
                    <div class="form_item_box_one">
                        <div class="form_label_one">产品:</div>
                        <div class="form_conter">
                            <Select filterable  transfer v-model="submitData.application_id" style="width:300px" placeholder="选择产品" clearable @on-change="chooseApp">
                                <Option v-for="item in applicationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div>      
                    <div class="form_item_box_one" v-if="submitData.application_id !== 0 ">
                        <div class="form_label_one">版本插件:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="submitData.version_plugin_id" style="width:300px" @on-change="chooseVersion" :placeholder="submitData.application_id ? '请选择版本插件' : '请先选择产品'" clearable>
                                <Option v-for="item in versionList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div>           
                    <!-- <div class="form_item_box_one">
                        <div class="form_label_one">版本:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="submitData.version_plugin_id" style="width:300px" @on-change="chooseVersion" :placeholder="submitData.application_id ? '请选择产品' : '请先选择版本'" clearable>
                                <Option v-for="item in versionList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div> -->
                    <div class="form_item_box_one">
                        <div class="form_label_one">插件:</div>
                        <div class="form_conter" style="height:auto">
                            <Select filterable  transfer multiple  v-model="chooseProductIds" style="width:300px" @on-change="chooseProduct" :placeholder="submitData.application_id?'请选择插件':'请先选择产品'" clearable>
                                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div>                    
                    <!-- <div class="form_item_box_one">
                        <div class="form_label_one">时限:</div>
                        <div class="form_conter">
                            <Input v-model="submitData.days" type="number" style="width:300px" placeholder="请输入多少天"></Input>                            
                        </div>
                    </div>  -->
                    <div v-for='(item,index) in productList' :key="index">                       
                        <div class="form_item_box_one"  v-if='item.int_type == 1 && (chooseProductIds.indexOf(item.id)!=-1)'>
                            <div class="form_label_one">{{item.title}}:</div>
                            <div class="form_conter" >
                                <Input v-model="item.num" type="number" style="width:300px" placeholder="请输入数量"></Input>                                                               
                            </div>
                            <div style="color:red;height: 32px;line-height: 32px;margin-left: 8px;">(* 0为无限制 )</div>  
                        </div>
                    </div>
                    
                    <div class="form_item_box_one">
                        <div class="form_label_one">详情信息:</div>
                        <div class="form_conter">
                            <editor :edtor-con="submitData.details_information" :index="1" @getContent="getEnContent" @getContentchange="getEnContentchange" style="width:800px"/>   
                        </div>                        
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="showAddModal = !showAddModal" >取消</Button>
                <Button @click="goSubmit()" style="background:#FF761D;color:#fff;border-color:#FF761D">确认</Button>                
            </div>
        </Modal>      
    </div>
</template>

<script>
    import editor from "@/components/editor/editor.vue";
    import { goods_list,edit_status,plugin_list,application_list,update_package,del_package } from "@/api/index";
    export default {
        
        components: { editor },
        data(){
            return{                               
                avatarView:'',
                showOrderModal:false,
                total:0,
                fkType:'weixin',
                chooseVersionIds: '',
                chooseProductIds: [],
                pageForm:{
                    page:1,
                    limit:10,
                    type:1,//0产品套餐 1插件套餐
                    application_id: '',
                    version_plugin_id: '',
                },
                searchVersionList: [],
                versionList: [],
                productList:[],
                plugin_object: [],
                submitData: { // 这里是需要携带的数据
                    type: 1,//0产品套餐 1插件套餐
                    name: '',//套餐名称
                    version_plugin_id: '',//	插件id
                    price: 0,//价格
                    num: '',//数量
                    days: '',//有效天数
                    package_id: '',//套餐id 修改套餐使用传值
                    application_id: '',//对应的产品
                    details_information: '',
                    plugin_id: '',
                    plugin_object:[]
                },
                addModalTitle : 'add',
                contentTexe:'',                
                uid:null,
                formData:{},
                fkmodal:false,
                showAddModal:false,
                columns12: [
                    // {type: 'selection',width: 60,align: 'center'},
                    {title: '#',slot: 'index',align: 'center',},
                    {title: '名称',key: 'name',align: 'center',},
                    {title: '套餐',slot: 'plugin',align: 'center',},
                    {title: '产品',slot: 'system',align: 'center',},
                    {title: '版本插件',slot: 'version_plugin_name',align: 'center',},
                    {title: '金额',key: 'price',align: 'center',},        
                    // {title: '时限(天)',key: 'days',align: 'center',},   
                    {title: '创建时间',key: 'created_at',align: 'center',},         
                    {title: '操作',slot: 'action',width: 220,fixed: 'right',align: 'center',}
                ],
                data6: [],
                loadingone:false,
                applicationList: [],
            }
        },
        created(){
            this.getList()            
            this.application_list()
        },
        methods:{
            goSearch(){
                this.pageForm.page = 1
                this.getList()
            },
            //富文本
            getEnContentchange(detailData) {
                this.submitData.details_information = detailData.editorData;
            },
            getEnContent(detailData) {
                this.submitData.details_information = detailData.editorData;
            },
            changeAppid(e){
                this.pageForm.version_plugin_id = ''
                if(e){
                    this.getSearchVersionList(e)
                }                
            },
            chooseApp(e){
                if(e){
                    this.chooseVersionIds = ''
                    this.chooseProductIds = []
                    this.no_plugin_list(e,'')
                    // this.get_plugin_list(e)                    
                }else if(e == 0){
                    console.log('00000')
                    this.chooseVersionIds = ''
                    this.chooseProductIds = []
                    this.submitData.version_plugin_id = ''
                    this.get_new_plugin_list(e) //当为公共插件时 版本插件不显示
                }else{
                    this.submitData.version_plugin_id = ''
                    this.chooseVersionIds = ''
                    this.chooseProductIds = []
                    this.versionList = []
                    this.productList = []
                }
            },
            get_new_plugin_list(e){
                let newPageForm={
                    page: 1,
                    limit: 9999,
                    type: 1,            
                    application_id:e
                }
                plugin_list(newPageForm).then(res=>{
                    this.productList = []
                    res.data.data.forEach(item=>{
                        if(this.addModalTitle =='add'){                            
                            item.num = 0
                            item.num = item.int_type ? 1 : 0
                        }
                        this.productList.push(item)
                    })
                    if(this.productList.length == 0){
                        this.$Message.error('该产品下暂无产品')
                    }
                })
            },    
            chooseVersion(e){
                // console.log('选中版本e',e)
                if(e){    
                    this.chooseProductIds = []               
                    this.get_plugin_list(this.submitData.version_plugin_id)                    
                }else {
                    this.chooseProductIds = []
                }
            },
            
            get_plugin_list(e){
                let newPageForm={
                    page: 1,
                    limit: 9999,
                    type: 1,            
                    application_id:this.submitData.application_id,
                    version_plugin_id: e
                }
                plugin_list(newPageForm).then(res=>{
                    this.productList = []
                    res.data.data.forEach(item=>{
                        if(this.addModalTitle =='add'){                            
                            item.num = 0
                            item.num = item.int_type ? 1 : 0
                        }
                        this.productList.push(item)
                    })
                    // this.productList = res.data.data
                    if(this.productList.length==0){
                        this.$Message.error('该产品下暂无产品')
                    }
                })
            }, 
            chooseProduct(e){
                // console.log('选中的产品',e)
            },
            addProduct(){
                this.showAddModal = true
                this.reast()
                this.addModalTitle = 'add'
            },
            reast(){    
                this.submitData.type = 1,//0产品套餐 1插件套餐
                this.submitData.name = '',//套餐名称
                this.submitData.version_plugin_id = '',//	插件id
                this.submitData.price = 0,//价格
                this.submitData.days = '',//有效天数
                this.submitData.package_id = '',//套餐id 修改套餐使用传值
                this.submitData.application_id = ''//对应的产品
                this.submitData.sort = 0
                this.submitData.details_information = ''
                this.submitData.plugin_id = '' 
                this.submitData.plugin_object = []
            },
            goSubmit(){
                this.submitData.days = 0
                const errorMessage = this.validateInput(this.submitData);                
                this.submitData.plugin_object = []
                if (errorMessage !== '') {
                    this.$Message.error(errorMessage);
                    return;
                }
                if(this.submitData.sort === ''){
                    this.submitData.sort = 0
                }
                let cango = false
                let plugin_object = []              
                console.log('this.productList',this.productList)  
                this.productList.forEach(item=>{
                    if((this.chooseProductIds.indexOf(item.id)!=-1)){
                        if(item.num === ''&&item.int_type == 1){
                            cango = true
                        }
                        plugin_object.push({plugin_id:item.id, num: item.int_type ? ( item.num ? item.num : 0 ) : '',name:item.title?item.title:item.name})
                    }
                })
                // plugin_object.push({plugin_id:this.submitData.version_plugin_id,num:0})
                if (cango) {
                    this.$Message.error('数量不能为空');
                    return;
                }
                this.submitData.plugin_object = JSON.parse(JSON.stringify(plugin_object))
                let pluginArr = []
                this.submitData.plugin_object.forEach(item=>{
                    pluginArr.push(item.plugin_id)
                })
                this.submitData.plugin_id = pluginArr.join()
                console.log('submitData',this.submitData)
                // return
                update_package(this.submitData).then(res=>{
                    this.$Message.success(res.msg)
                    this.getList()
                    this.showAddModal = false
                }).catch(err=>{
                    this.$Message.error(err.msg)
                })
            },
            validateInput(submitData) {
                if (submitData.application_id === '') {
                    return '请选择产品';
                }                
                if (submitData.name == '') {
                    return '请输入套餐名称';
                }
                if (submitData.price === '') {
                    return '请输入产品价格';
                }
                // if (submitData.days == '') {
                //     return '请输入时限';
                // }
                return '';
            },
            chooseData(e){
                console.log('e',e)
            },            
            application_list(){
                this.applicationList = []
                application_list({ type:0 }).then(res=>{
                    this.applicationList = res.data
                    // this.applicationList.push({id:0,name:'公共插件'})
                })
            },
            getList(){
                this.loadingone = true ;
                goods_list(this.pageForm).then(res=>{
                    this.loadingone = false
                    this.total = res.data.total
                    this.data6 = res.data.data
                })
            },
            no_plugin_list(e,type,x){
                let newPageForm={
                    page: 1,
                    limit: 9999,
                    type: 0,            //0产品 1插件
                    application_id:e
                }
                plugin_list(newPageForm).then(res=>{
                    this.versionList = []
                    this.versionList = res.data.data
                    if(type=='edit'){
                        this.get_edit_plugin_list(x.application_id , x.plugin_object ? x.plugin_object : [],x.version_plugin_id)  
                        this.submitData.version_plugin_id  = x.version_plugin_id
                    }
                    if(this.versionList.length==0){
                        this.$Message.error('该产品下暂无版本')
                    }
                })
            },
            getSearchVersionList(e){
                let newPageForm={
                    page: 1,
                    limit: 9999,
                    type: 0,            //0产品 1插件
                    application_id:e
                }
                plugin_list(newPageForm).then(res=>{
                    this.searchVersionList = []
                    this.searchVersionList = res.data.data
                    if(this.searchVersionList.length==0){
                        this.$Message.error('该产品下暂无版本插件')
                    }
                })
            },
              
            goEdit(e){                
                this.addModalTitle = 'edit'
                this.showAddModal = true
                this.submitData.package_id = e.id//套餐id 修改套餐使用传值
                this.submitData.days = e.days,//有效天数
                this.submitData.type = 1,//0产品套餐 1插件套餐
                this.submitData.name = e.name,//套餐名称
                this.submitData.price = e.price*1,//价格
                this.submitData.sort = e.sort
                this.submitData.application_id = e.application_id//对应的产品
                this.submitData.details_information = e.describe   
                this.chooseVersionIds = ''   
                console.log('e.application_id',e.application_id)        
                if(e.application_id){
                    // 非公共插件
                    this.no_plugin_list(e.application_id,'edit',e)       
                    // this.get_edit_plugin_list(e.application_id , e.plugin_object ? e.plugin_object : [],e.version_plugin_id)                    
                }else{
                    //是公共插件的插件套餐
                    // this.get_new_plugin_list(e.application_id)
                    this.get_edit_plugin_list(e.application_id , e.plugin_object ? e.plugin_object : [],e.version_plugin_id)
                }
                // this.chooseAPPID = e.plugin_id.split(",").map(Number);
                this.submitData.version_plugin_id  = e.version_plugin_id
            },    
            get_edit_plugin_list(e,arrData,version_plugin_id){
                let newPageForm = {}
                if(e){
                    newPageForm = {
                        page: 1,
                        limit: 9999,
                        type: 1,            
                        application_id:e,
                        version_plugin_id:version_plugin_id
                    }
                }else{
                    newPageForm = {
                        page: 1,
                        limit: 9999,
                        type: 1,            
                        application_id:version_plugin_id,
                    }
                }                
                plugin_list(newPageForm).then(res=>{
                    this.productList = []
                    res.data.data.forEach(item=>{                           
                        item.num = item.num ? item.num : 0   
                        // item.num = 0                    
                        this.productList.push(item)
                    })
                    this.chooseProductIds = []
                    arrData.forEach(item =>{
                        this.chooseProductIds.push(item.plugin_id)
                        this.productList.forEach(itemA=>{
                            if(itemA.id == item.plugin_id){
                                itemA.num = item.num ? item.num :0
                            }
                        })
                    })
                    
                    // this.productList = res.data.data                    
                })
            },         
            del_use(e){
                this.$Modal.confirm({
                    title: '提示',
                    content: `是否确认删除该套餐`,
                    onOk: () => {
                        del_package({package_id:e.id}).then(res=>{
                            this.$Message.success(res.msg)
                            this.getList()
                        }).catch(err=>{
                            this.$Message.error(err.msg)
                            this.getList()
                        })
                    },
                    onCancel: () => {
                    }
                });
            },
            pageChange(e){
                this.pageForm.page = e
                this.getList()
            }
        }
    }
</script>

<style scoped>
.form_box_two {
    width: 100%;
    min-height: 600px;
    max-height: 600px;
    overflow-y: auto;
}
.form_item_box_one {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin:16px 0 ;
}
.form_label_one {
    width: 130px;
    text-align: end;
    height: 32px;
    line-height: 32px;
    padding-right: 24px;
}
.flex_btw{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.nochoose_box{
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-top: 0.5px solid rgb(180, 180, 180);
    border-left: 0.5px solid rgb(180, 180, 180);    
    border-bottom: 0.5px solid rgb(180, 180, 180);
    cursor: pointer;
    /* border-radius: 4px; */
}
.choose_box{
    cursor: pointer;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-top: 0.5px solid rgb(180, 180, 180);
    border-left: 0.5px solid rgb(180, 180, 180);    
    border-bottom: 0.5px solid rgb(180, 180, 180);
    background: #FF761D;
    color: #fff;
}

    .modal_contene{
        /* height: 500px; */
        overflow: auto;
    }
    .user_pic_box{
        margin: 10px 0;
        width: 70px;
        height: 70px;
    }
    .flex_sta {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .user_pic_box img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;
    }
    .Photo_wall{
        display: flex;
        align-items: center;
    }
   
    .photo_box img{
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 10px;
        margin-right: 5px;
    }
    .btn{
        background: #FF761D;
        color: #0A1629;
    }
    .head_portrait{
        display: flex;
        flex-wrap: wrap;
    }
    .fk_class {
        width:300px;
    }
    .viewimg{
        position: relative;
        width: 80px;
        height: 80px;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 10px;
        overflow: hidden;
    }
    .viewimg img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .absolu_close:hover{
        opacity: 1;
    }
    .flex_cen {
        position: relative;
    }
    .san_class {
       display: flex;
       justify-content: flex-end;
       align-items: flex-end;
    }
    .absolu_close{
        cursor: pointer;
        position: absolute;
        top: 0;
        opacity: 0;
        left: 0;
        width: 80px;
        height: 80px;
        background: rgba(0,0,0,.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .upload_img{
        cursor: pointer;
        width: 80px;
        height: 80px;
        border: 1px solid #eee;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .upload_img_txt{
        margin-top: -10px;
        font-size: 12px;
        color: #999;
    }
    .just_content{
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
<style>
    .ivu-table-header thead tr th {
        background: #fff !important;
    }
    .ivu-table-fixed-header thead tr th{
        background: #fff !important;
    }
    .ivu-table td, .ivu-table th {
        border-bottom: 1px solid #F0F6FC;
        color: #74798C;
    }
    .ivu-table:before{
        background: unset;
    }
    /* .ivu-modal-content{
        overflow: hidden;
    } */
    .ivu-modal-header{
        background: #fff;
    }
    .ivu-modal-close .ivu-icon-ios-close{
        color: #0A1629;
    }
    .ivu-modal-footer{
        border-top: unset;
    }
</style>